import { yccasterapi, taskmanager } from '@/http.js';

class CommandService {
    async sendCommand(imei, mountpoint, taskType) {
        const commandData = {
            imei,
            mountpoint,
            taskType,
        };
        return await taskmanager.post('/tasks/force-execute', commandData);
    }

    async sendToSleep(imei, userId) {
        return await yccasterapi.post('idle-commands/send-to-sleep', { imei, userId });
    }

    async wakeUp(imei, userId) {
        return await yccasterapi.post('idle-commands/wake-up', { imei, userId });
    }
}
export default new CommandService();
